import styled from "@emotion/styled";
import { NavbarButton } from "./NavbarButton";
import { WavyClose, WavyHamburger } from "components/Icons";
import { NavbarLinkItem } from "./NavbarLinkItem";
import { linkItems } from "../NavbarV2Desktop";
import { GlobalStore } from "store/global/GlobalStore";
import { useDisplayOnClick } from "hooks/useDisplayOnClick";
import { getNavbarButtonCss } from "./NavbarLinks";

export const NavbarLinksTablet = () => {
  const { isDisplayed, elementToClickRef, elementToDisplayRef, onClick, forceClose } =
    useDisplayOnClick();
  const theme = GlobalStore.useState(s => s.theme);

  return (
    <NavbarLinksContainer
      ref={elementToClickRef as React.Ref<HTMLDivElement>}
      onClick={onClick}
      isDisplayed={isDisplayed}
    >
      <NavbarButton
        symbol={{
          active: WavyClose,
          default: isDisplayed ? WavyClose : WavyHamburger,
        }}
        text="More"
        css={getNavbarButtonCss(theme, isDisplayed)}
        colors={{ hover: theme["Brand colours"].Sea }}
      />
      <PopupContainer
        ref={elementToDisplayRef as React.Ref<HTMLDivElement>}
        isDisplayed={isDisplayed}
        onClick={forceClose}
      >
        {linkItems.map(item => (
          <NavbarLinkItem key={item.text} {...item} />
        ))}
      </PopupContainer>
    </NavbarLinksContainer>
  );
};

// Sub-components

const NavbarLinksContainer = styled.div<{ isDisplayed: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 200%;
`;

const PopupContainer = styled.div<{ isDisplayed: boolean }>`
  display: ${props => (props.isDisplayed ? "flex" : "none")};
  flex-direction: column;
  width: 250px;
  position: absolute;
  left: 70px;
  top: 20px;
  padding: 8px;
  align-items: flex-start;
  border-radius: 20px;
  background: ${props => props.theme.surface.main.primary.hover};
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  opacity: 0.5;
  animation: slide 0.25s ease-in-out forwards;

  @keyframes slide {
    100% {
      top: 0;
      opacity: 1;
    }
  }
`;
